"use client";

import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import React, { lazy, Suspense } from "react";

import { isIdentityVerificationModalOrRoute } from "@faire/retailer/components/App/AppModals/utils";
import { isMobileApp } from "@faire/retailer/lib/isMobileApp";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";
import { usePromoBanners } from "@faire/retailer/stores/ui/usePromoBanners";

export const LazyPromoBanner: React.FC = () => {
  const isSSR = useIsSSR();

  const { isVisible: isPromoBannerVisible } = usePromoBanners();

  if (
    isSSR ||
    !isPromoBannerVisible ||
    (isMobileApp() && isIdentityVerificationModalOrRoute())
  ) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LazyPromoBannerBase />
    </Suspense>
  );
};

const LazyPromoBannerBase = lazy(() =>
  import(/* webpackChunkName: "retailer-promo-banner" */ "./PromoBanner")
    .then((m) => ({ default: m.PromoBanner }))
    .catch(handleComponentLoadError)
);
